import { RegistrationReceipt } from "./types";

// The confirmation page shows the details just submitted. They're kept in this tab's
// sessionStorage (cleared when the tab closes) because, in production, visitors can't read
// registrations back from the database: only administrators can.

const key = (reference: string) => `km-webinar-receipt:${reference}`;

export function saveReceipt(receipt: RegistrationReceipt) {
  try {
    sessionStorage.setItem(key(receipt.reference), JSON.stringify(receipt));
  } catch {
    // Storage blocked: the page still gets the receipt through navigation state
  }
}

export function loadReceipt(reference: string): RegistrationReceipt | null {
  try {
    const stored = sessionStorage.getItem(key(reference));
    return stored ? (JSON.parse(stored) as RegistrationReceipt) : null;
  } catch {
    return null;
  }
}
